import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  TablePagination,
  InputAdornment,
  Tabs,
  Tab,
  LinearProgress,
  IconButton,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import dayjs from "dayjs";
import { BASE_URL } from "../../constants";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ArrowRight } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { logout } from "../../utils/api";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
}

const PatientForm = () => {
  const centre = useRecoilValue(authState);
  const setAuth = useSetRecoilState(authState);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    visitingDate: dayjs().format("YYYY-MM-DD"),
    patientName: "",
    patientAge: "",
    patientSex: "",
    patientPhone: "",
    doctor: "",
  });
  const [doctors, setDoctors] = useState([]);
  const [opds, setOpds] = useState([]);
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState(0);
  const today = new Date().toISOString().split("T")[0];
  const [startDateOpd, setStartDateOpd] = useState(today);
  const [endDateOpd, setEndDateOpd] = useState(today);
  const [loadingOpd, setLoadingOpd] = useState(null);
  const [startDateBill, setStartDateBill] = useState(today);
  const [endDateBill, setEndDateBill] = useState(today);
  const [loadingBill, setLoadingBill] = useState(null);
  const centerId = centre?.centreId || "";
  const centerName = centre?.centreName || "Centre";
  const orgName = centre?.orgName || "";

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLogout = async () => {
    await logout();
    setAuth(null);
    navigate("/centre/login", { replace: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...formData, doctor: formData.doctor || null };
      const response = await fetch(`${BASE_URL}api/centre/create-patient`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.success) {
        fetchPatients();
        setFormData({
          visitingDate: dayjs().format("YYYY-MM-DD"),
          patientName: "",
          patientAge: "",
          patientSex: "",
          patientPhone: "",
          doctor: "",
        });
        setTab(1);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllDoctors = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/centre/get-all-doctors`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setDoctors(data.doctors || []);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchPatients = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/centre/get-all-ref-patient`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setPatients(data.data);
      }
    } catch (err) {
      setError("Error fetching patients");
    } finally {
      setLoading(false);
    }
  };

  const fetchOpd = async (sd, ed) => {
    try {
      setLoadingOpd(true);
      const response = await fetch(
        `${BASE_URL}api/centre/confirmed-opd?startDate=${sd}&endDate=${ed}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      console.log("OPDDATA", data);
      if (data.success) {
        setOpds(data.data);
      }
    } catch (err) {
      setError("Error fetching patients");
    } finally {
      setLoadingOpd(false);
    }
  };
  const fetchBill = async (sd, ed) => {
    try {
      setLoadingBill(true);
      const response = await fetch(
        `${BASE_URL}api/centre/confirmed-bill?startDate=${sd}&endDate=${ed}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setBills(data.data);
      }
    } catch (err) {
      setError("Error fetching patients");
    } finally {
      setLoadingBill(false);
    }
  };
  console.log("bills", bills);
  useEffect(() => {
    fetchAllDoctors();
    fetchPatients();
    fetchOpd(startDateOpd, endDateOpd);
    fetchBill(startDateOpd, endDateOpd);
  }, []);

  const filteredPatients = patients.filter((p) =>
    p.patientName?.toLowerCase().includes(search.toLowerCase())
  );
  const filteredOpds = opds.filter((p) =>
    p.patientId.name?.toLowerCase().includes(search.toLowerCase())
  );
  const filteredBills = bills.filter((p) =>
    p.patientId.name?.toLowerCase().includes(search.toLowerCase())
  );
  console.log("BILLS", bills);
  const handleChangePage = (_, newPage) => setPage(newPage);

  const getRangeDataOpd = async () => {
    fetchOpd(startDateOpd, endDateOpd);
  };
  const getRangeDataBill = async () => {
    fetchBill(startDateBill, endDateBill);
  };
  const getStatus = (status) => {
    if (status === "approved")
      return (
        <>
          <CheckCircleOutlineIcon color="success" /> <span>Approved</span>
        </>
      );
    else if (status === "rejected")
      return (
        <>
          <CancelIcon color="error" /> <span>Rejected</span>
        </>
      );
    else
      return (
        <>
          <ErrorOutlineIcon color="warning" /> <span>Pending</span>
        </>
      );
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
        <CircularProgress sx={{ color: "#f97316" }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" mt={4}>
        {error}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fff7ed, #fef9c3)",
      }}
    >
      {/* Navbar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 2,
          background: "linear-gradient(90deg, #f97316, #facc15)",
          color: "white",
          fontWeight: 600,
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        }}
      >
        <Typography variant="body1">
          <div>
            <span>{centerName} </span>
            <strong>({centerId})</strong>
          </div>
          <div>
            <strong>{orgName}</strong>
          </div>
        </Typography>

        <Button
          variant="contained"
          onClick={handleLogout}
          sx={{
            backgroundColor: "white",
            color: "#f97316",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { backgroundColor: "#fef3c7" },
          }}
        >
          Logout
        </Button>
      </Box>

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          textColor="inherit"
          TabIndicatorProps={{
            style: {
              background: "linear-gradient(90deg, #f97316 0%, #facc15 100%)",
              height: "4px",
              borderRadius: "2px",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              fontWeight: 600,
              color: "#374151",
              textTransform: "none",
              "&.Mui-selected": { color: "#f97316" },
            },
          }}
        >
          <Tab label="Refer Patient" />
          <Tab label="Referred List" />
          <Tab label="Confirmed OPD" />
          <Tab label="Confirmed Bill" />
        </Tabs>

        <TabPanel value={tab} index={0}>
          <Paper
            elevation={4}
            sx={{
              p: 4,
              borderRadius: 4,
              maxWidth: 600,
              mx: "auto",
              background: "#fff9f0",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
            }}
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {[
                  {
                    name: "visitingDate",
                    label: "Visiting Date",
                    type: "date",
                  },
                  {
                    name: "patientName",
                    label: "Patient Name",
                    required: true,
                  },
                  { name: "patientAge", label: "Age", type: "number" },
                  {
                    name: "patientSex",
                    label: "Sex",
                    select: true,
                    options: ["Male", "Female", "Other"],
                  },
                  { name: "patientPhone", label: "Phone Number", type: "tel" },
                ].map((field, i) => (
                  <Grid
                    item
                    xs={12}
                    sm={
                      field.name === "patientAge" || field.name === "patientSex"
                        ? 6
                        : 12
                    }
                    key={i}
                  >
                    <TextField
                      fullWidth
                      {...field}
                      select={field.select || false}
                      value={formData[field.name]}
                      onChange={handleChange}
                      InputLabelProps={
                        field.type === "date" ? { shrink: true } : {}
                      }
                    >
                      {field.options?.map((opt) => (
                        <MenuItem key={opt} value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    name="doctor"
                    label="Select Doctor"
                    value={formData.doctor}
                    onChange={handleChange}
                  >
                    <MenuItem value="">-- None --</MenuItem>
                    {doctors?.map((doc, index) => (
                      <MenuItem key={index} value={doc._id}>
                        {doc.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    startIcon={<AddCircleOutlineIcon />}
                    sx={{
                      py: 1.4,
                      fontSize: "16px",
                      borderRadius: "12px",
                      textTransform: "none",
                      background:
                        "linear-gradient(90deg, #f97316 0%, #facc15 100%)",
                      "&:hover": {
                        background:
                          "linear-gradient(90deg, #ea580c 0%, #eab308 100%)",
                      },
                    }}
                  >
                    Register Patient
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </TabPanel>
        {/* List */}
        <TabPanel value={tab} index={1}>
          <Box width="100%">
            <Box mb={2} display="flex" justifyContent="flex-end">
              <TextField
                size="small"
                fullWidth
                placeholder="Search by name..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: "#f97316" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  backgroundColor: "#fff",
                }}
              />
              <IconButton onClick={fetchPatients}>
                <RefreshIcon />
              </IconButton>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 3,
                boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
                overflowX: "auto",
              }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ background: "#fef3c7" }}>
                    {[
                      "Visit Date",
                      "Name",
                      "Age",
                      "Sex",
                      "Phone",
                      "Doctor",
                      "Status",
                    ].map((header, i) => (
                      <TableCell
                        key={i}
                        sx={{ fontWeight: "bold", color: "#374151" }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredPatients.length > 0 ? (
                    filteredPatients
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((patient) => (
                        <TableRow
                          key={patient._id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#fff7ed",
                            },
                            "&:hover": {
                              backgroundColor: "#fffbeb",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <TableCell>
                            {new Date(patient.visitingDate)
                              .toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "short",
                                year: "2-digit",
                              })
                              .replace(" ", "'")}
                          </TableCell>
                          <TableCell>{patient.patientName}</TableCell>
                          <TableCell>{patient.patientAge || "-"}</TableCell>
                          <TableCell>{patient.patientSex || "-"}</TableCell>
                          <TableCell>{patient.patientPhone || "-"}</TableCell>
                          <TableCell>{patient?.doctor?.name || "-"}</TableCell>
                          <TableCell>{getStatus(patient?.status)}</TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No patients found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredPatients.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
            />
          </Box>
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <Box width="100%">
            <Box mb={2} display="flex" justifyContent="flex-end">
              <TextField
                size="small"
                fullWidth
                placeholder="Search by name..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: "#f97316" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  backgroundColor: "#fff",
                }}
              />
              <IconButton onClick={() => fetchOpd(startDateOpd, endDateOpd)}>
                <RefreshIcon />
              </IconButton>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 3,
                boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
                overflowX: "auto",
              }}
            >
              <Box sx={{ display: "flex", m: 1 }}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: "#f0fdf4", // tailwind: bg-green-50
                    borderRadius: "5px",
                    border: "1px solid #bbf7d0", // tailwind: border-green-200
                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    maxHeight: 36,
                    p: 1,
                    mr: 1,
                  }}
                >
                  {opds.length}
                </Box>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginLeft: "auto",
                  }}
                >
                  <input
                    type="date"
                    value={startDateOpd}
                    onChange={(e) => setStartDateOpd(e.target.value)}
                    max={endDateOpd}
                    disabled={loading}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #d1d5db",
                      padding: "0px 5px",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                    }}
                  />
                  <button
                    style={{
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                      color: "#000",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      padding: "0px 5px",
                      position: "relative",
                    }}
                    onClick={getRangeDataOpd}
                  >
                    <ArrowRight />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                        left: "22px",
                      }}
                    >
                      🔍︎
                    </span>
                  </button>
                  <input
                    type="date"
                    value={endDateOpd}
                    onChange={(e) => setEndDateOpd(e.target.value)}
                    min={startDateOpd}
                    disabled={loadingOpd}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #d1d5db",
                      padding: "0px 5px",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                    }}
                  />
                </div>
              </Box>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ background: "#fef3c7" }}>
                    {/* {["Apt. Id", "Apt. Date", "Patient", "Doctor"].map( */}
                    {[
                      { label: "Apt. ID", minWidth: 120 },
                      { label: "Apt. Date", minWidth: 160 },
                      { label: "Patient", minWidth: 160 },
                      { label: "Doctor", minWidth: 150 },
                    ].map((header, i) => (
                      <TableCell
                        key={i}
                        sx={{
                          fontWeight: "bold",
                          color: "#374151",
                          minWidth: header.minWidth,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {header.label}
                      </TableCell>
                    ))}
                  </TableRow>
                  {loadingOpd && (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ padding: 0 }}>
                        <LinearProgress
                          color="success"
                          sx={{ height: 2, width: "100%" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableHead>

                <TableBody>
                  {filteredOpds?.length > 0 ? (
                    filteredOpds
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((patient) => (
                        <TableRow
                          key={patient._id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#fff7ed",
                            },
                            "&:hover": {
                              backgroundColor: "#fffbeb",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <TableCell>{patient.appointmentId}</TableCell>
                          <TableCell>
                            {new Date(patient.appDate)
                              .toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "short",
                                year: "2-digit",
                              })
                              .replace(" ", "'")}
                          </TableCell>
                          <TableCell>{patient.patientId.name}</TableCell>
                          <TableCell>{patient.doctorId.name}</TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No patients Confirmed Yes
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredOpds.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
            />
          </Box>
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <Box width="100%">
            <Box mb={2} display="flex" justifyContent="flex-end">
              <TextField
                size="small"
                fullWidth
                placeholder="Search by name..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: "#f97316" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  backgroundColor: "#fff",
                }}
              />
              <IconButton onClick={() => fetchBill(startDateBill, endDateBill)}>
                <RefreshIcon />
              </IconButton>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 3,
                boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
                overflowX: "auto",
                // minWidth: "800px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  margin: "5px",
                }}
              >
                <input
                  type="date"
                  value={startDateBill}
                  onChange={(e) => setStartDateBill(e.target.value)}
                  max={endDateBill}
                  disabled={loadingBill}
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    padding: "0px 5px",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  }}
                />
                <button
                  style={{
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid #d1d5db",
                    outline: "none",
                    padding: "0px 5px",
                    position: "relative",
                  }}
                  onClick={getRangeDataBill}
                >
                  <ArrowRight />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "-8px",
                      left: "22px",
                    }}
                  >
                    🔍︎
                  </span>
                </button>
                <input
                  type="date"
                  value={endDateBill}
                  onChange={(e) => setEndDateBill(e.target.value)}
                  min={startDateBill}
                  disabled={loadingBill}
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    padding: "0px 5px",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  }}
                />
              </div>
              <Box sx={{ display: "flex", m: 1 }}>
                <Box>
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#f0fdf4", // tailwind: bg-green-50
                      borderRadius: "5px",
                      border: "1px solid #bbf7d0", // tailwind: border-green-200
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      maxHeight: 36,
                      p: 1,
                      mr: 1,
                    }}
                  >
                    {bills.length}
                  </Box>

                  <Chip
                    label={
                      "Grand Total: ₹" +
                      bills
                        ?.reduce(
                          (sum, inv) =>
                            sum + (inv.calculations?.finalTotal || 0),
                          0
                        )
                        .toLocaleString("en-IN")
                    }
                  />
                </Box>
              </Box>
              {/* <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ background: "#fef3c7" }}>
                    {[
                      { label: "Invoice ID", minWidth: 120 },
                      { label: "Name", minWidth: 160 },
                      { label: "Total", minWidth: 120 },
                      { label: "Discount Offered", minWidth: 160 },
                      { label: "Final Total", minWidth: 150 },
                    ].map((col, i) => (
                      <TableCell
                        key={i}
                        sx={{
                          fontWeight: "bold",
                          color: "#374151",
                          minWidth: col.minWidth,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                  {loadingBill && (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ padding: 0 }}>
                        <LinearProgress
                          color="success"
                          sx={{ height: 2, width: "100%" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableHead>

                <TableBody>
                  {filteredBills.length > 0 ? (
                    filteredBills
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((patient) => (
                        <TableRow
                          key={patient._id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#fff7ed",
                            },
                            "&:hover": {
                              backgroundColor: "#fffbeb",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <TableCell>{patient.invoiceId || "-"}</TableCell>
                          <TableCell>{patient.patientId.name || "-"}</TableCell>
                          <TableCell>
                            ₹{" "}
                            {patient.calculations.grandTotal.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>
                          <TableCell>
                            ₹{" "}
                            {patient.calculations.totalDiscountOffered.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>
                          <TableCell>
                            ₹{" "}
                            {patient.calculations.finalTotal.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No patients found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table> */}
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ background: "#fef3c7" }}>
                    {[
                      { label: "Invoice ID", minWidth: 120 },
                      { label: "Name", minWidth: 160 },
                      { label: "Total", minWidth: 120 },
                      { label: "Discount Offered", minWidth: 160 },
                      { label: "Final Total", minWidth: 150 },
                    ].map((col, i) => (
                      <TableCell
                        key={i}
                        sx={{
                          fontWeight: "bold",
                          color: "#374151",
                          minWidth: col.minWidth,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                  {loadingBill && (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ padding: 0 }}>
                        <LinearProgress
                          color="success"
                          sx={{ height: 2, width: "100%" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableHead>

                <TableBody>
                  {filteredBills.length > 0 ? (
                    filteredBills
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((patient) => (
                        <TableRow
                          key={patient._id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#fff7ed",
                            },
                            "&:hover": {
                              backgroundColor: "#fffbeb",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <TableCell>{patient.invoiceId || "-"}</TableCell>
                          <TableCell>{patient.patientId.name || "-"}</TableCell>

                          {/* Total */}
                          <TableCell
                            sx={{
                              backgroundColor: "#ecfdf5", // green-50
                              color: "#065f46", // green-700
                              fontWeight: 500,
                              borderRadius: 1,
                            }}
                          >
                            ₹{" "}
                            {patient.calculations.grandTotal.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>

                          {/* Discount */}
                          <TableCell
                            sx={{
                              backgroundColor: "#fef2f2", // red-50
                              color: "#b91c1c", // red-700
                              fontWeight: 500,
                              borderRadius: 1,
                            }}
                          >
                            ₹{" "}
                            {patient.calculations.totalDiscountOffered.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>

                          {/* Final Total */}
                          <TableCell
                            sx={{
                              backgroundColor: "#eff6ff", // blue-50
                              color: "#1e3a8a", // blue-900
                              fontWeight: 600,
                              borderRadius: 1,
                            }}
                          >
                            ₹{" "}
                            {patient.calculations.finalTotal.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No patients found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredBills.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
            />
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};

export default PatientForm;
